import * as Sentry from '@sentry/browser';
import { ErrorHandler, Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '~env/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { CheckoutCommonUtil } from '~app/modules/checkout/utils/checkout-common-util';

@Injectable({
  providedIn: 'root',
})
export class SentryErrorHandler implements ErrorHandler {
  constructor(
    @Inject(PLATFORM_ID)
    private readonly platformId: Object
  ) {}

  handleError(error) {
    if (!isPlatformBrowser(this.platformId) || !environment.sentryDsn()) {
      // Skip errors when we don't have proper env dns url for Sentry
      return;
    }

    // Ignore sending of cors issues to Sentry
    if (error && error.sourceError instanceof HttpErrorResponse && error.sourceError.status === 0) {
      return;
    }

    const sessionId = CheckoutCommonUtil.getSessionIdFromSessionStorage();

    Sentry.captureException(error.originalError || error.error || error, {
      tags: {
        error_type: 'Error handler',
      },
      contexts: {
        user: {
          session_id: sessionId,
        },
      },
    });
  }
}
